<template>
    <div class="table">
        <!-- 查询条件 -->
        <div style="margin-bottom:10px;">
            <el-select v-model="form.deptId" placeholder="请选择学校" style="width:160px;" @change="common.page=1;getData()">
                <el-option
                    v-for="item in depts"
                    :key="item.id"
                    :label="item.name"
                    :value="item.id">
                </el-option>
            </el-select>
            &nbsp;
            <el-date-picker
                v-model="form.dateRange"
                type="daterange"
                range-separator="至"
                start-placeholder="开始日期"
                end-placeholder="结束日期"
                format="yyyy-MM-dd"
                value-format="yyyy-MM-dd"
                style="width:280px;">
            </el-date-picker>
            &nbsp;
            <el-button type="primary" icon="search" @click="common.page=1;getData()">查询</el-button>
            <el-button type="primary" @click="showExchangeDialog()">一键兑币</el-button>
        </div>

        <el-table
            :data="data"
            style="width:100%;margin-bottom:20px;"
            height="550"
            v-loading="loading"
            element-loading-text="数据正在加载中..."
            element-loading-background="rgba(255,255,255,0.7)"
            border>
            <el-table-column type="index" label="序号" width="55" :index="indexMethod"></el-table-column>
            <el-table-column prop="exchangeClass" label="兑换班级" :show-overflow-tooltip="true"></el-table-column>
            <el-table-column prop="exchangeCoin" label="兑换面额" :show-overflow-tooltip="true"></el-table-column>
            <el-table-column prop="gmtCreate" label="兑换时间" width="160"></el-table-column>
            <el-table-column prop="status" label="状态" width="90">
                <template slot-scope="scope">
                    <span v-if="scope.row.status == 1" style="color:#67C23A;">兑换成功</span>
                    <span v-else-if="scope.row.status == 2" style="color:#909399;">撤销</span>
                </template>
            </el-table-column>
            <el-table-column prop="createName" label="兑换人" width="100"></el-table-column>
            <el-table-column fixed="right" label="操作" width="130">
                <template slot-scope="scope">
                    <el-button type="text" size="small" style="color:#387EE8;" @click="exportExcel(scope.row)">下载兑币清单</el-button>
                    <el-button v-if="scope.row.status == 1" type="text" size="small" style="color:#E6A23C;" @click="revoke(scope.row)">撤销</el-button>
                    <el-button v-if="scope.row.status == 2" type="text" size="small" style="color:red;" @click="del(scope.row)">删除</el-button>
                </template>
            </el-table-column>
        </el-table>

        <div class="pagination">
            <el-pagination
                @size-change="handleSizeChange"
                @current-change="handleCurrentChange"
                :current-page="common.page"
                :page-size="common.pageSize"
                :page-sizes="common.allSizes"
                layout="total,sizes,prev,pager,next,jumper"
                :total="common.total">
            </el-pagination>
        </div>

        <!-- 一键兑币弹框 -->
        <el-dialog title="一键兑币" :visible.sync="exchangeVisible" :close-on-click-modal="false" width="460px">
            <el-form ref="exchangeForm" :model="exchangeForm" :rules="exchangeRules" label-width="100px">
                <el-form-item prop="exchangeClass" label="兑换班级">
                    <el-cascader
                        v-model="exchangeForm.exchangeClass"
                        :options="classOptions"
                        :props="cascaderProps"
                        placeholder="请选择兑换班级"
                        style="width:300px;"
                        clearable
                        filterable></el-cascader>
                </el-form-item>
                <el-form-item prop="exchangeCoinArr" label="兑换面额">
                    <el-select v-model="exchangeForm.exchangeCoinArr" placeholder="请选择兑换面额" style="width:300px;" multiple filterable clearable>
                        <el-option
                            v-for="item in coinOptions"
                            :key="item.id"
                            :label="item.label"
                            :value="item.id">
                        </el-option>
                    </el-select>
                </el-form-item>
            </el-form>
            <span slot="footer">
                <el-button @click="exchangeVisible=false">取 消</el-button>
                <el-button type="primary" @click="saveExchange()">确 定</el-button>
            </span>
        </el-dialog>

        <!-- 兑换结果弹框 -->
        <el-dialog title="兑换结果" :visible.sync="resultVisible" :close-on-click-modal="false" width="650px">
            <!-- 汇总统计 -->
            <div style="margin-bottom:15px;display:flex;gap:20px;">
                <div style="padding:10px 18px;border-radius:4px;background:#f0f9eb;color:#67C23A;font-weight:bold;">
                    兑换成功：{{resultData.successList.length}} 条
                </div>
                <div style="padding:10px 18px;border-radius:4px;background:#fef0f0;color:#F56C6C;font-weight:bold;">
                    兑换失败：{{resultData.errorList.length}} 条
                </div>
                <div style="padding:10px 18px;border-radius:4px;background:#fdf6ec;color:#E6A23C;font-weight:bold;">
                    库存不足：{{resultData.stockErrorList.length}} 条
                </div>
            </div>
            <!-- 明细列表 -->
            <div style="max-height:400px;overflow-y:auto;">
                <div v-if="resultData.successList.length > 0" style="margin-bottom:12px;">
                    <div style="font-weight:bold;color:#67C23A;margin-bottom:6px;">兑换成功明细</div>
                    <div style="padding:8px 12px;background:#f0f9eb;border-radius:4px;border-left:3px solid #67C23A;max-height:150px;overflow-y:auto;">
                        <div v-for="(item, index) in resultData.successList" :key="'s'+index" style="color:#67C23A;line-height:1.8;">
                            {{item}}
                        </div>
                    </div>
                </div>
                <div v-if="resultData.errorList.length > 0" style="margin-bottom:12px;">
                    <div style="font-weight:bold;color:#F56C6C;margin-bottom:6px;">兑换失败明细</div>
                    <div style="padding:8px 12px;background:#fef0f0;border-radius:4px;border-left:3px solid #F56C6C;max-height:150px;overflow-y:auto;">
                        <div v-for="(item, index) in resultData.errorList" :key="'e'+index" style="color:#F56C6C;line-height:1.8;">
                            {{item}}
                        </div>
                    </div>
                </div>
                <div v-if="resultData.stockErrorList.length > 0" style="margin-bottom:12px;">
                    <div style="font-weight:bold;color:#E6A23C;margin-bottom:6px;">库存不足明细</div>
                    <div style="padding:8px 12px;background:#fdf6ec;border-radius:4px;border-left:3px solid #E6A23C;max-height:150px;overflow-y:auto;">
                        <div v-for="(item, index) in resultData.stockErrorList" :key="'k'+index" style="color:#E6A23C;line-height:1.8;">
                            {{item}}
                        </div>
                    </div>
                </div>
            </div>
            <span slot="footer">
                <el-button type="primary" @click="resultVisible=false">关 闭</el-button>
            </span>
        </el-dialog>
    </div>
</template>

<script>
    import axios from 'axios';
    import http from '../../../../common/http';

    export default {
        name: "CoinExchange",
        data() {
            return {
                loading: false,
                exchangeVisible: false,
                resultVisible: false,
                resultData: {
                    successList: [],
                    errorList: [],
                    stockErrorList: []
                },
                common: {
                    total: 0,
                    pageSize: 20,
                    page: 1,
                    allSizes: [20, 50, 100]
                },
                form: {
                    deptId: "",
                    dateRange: []
                },
                depts: [],
                data: [],
                exchangeForm: {
                    exchangeClass: [],
                    exchangeCoinArr: []
                },
                exchangeRules: {
                    exchangeClass: [
                        { required: true, message: '请选择兑换班级', trigger: 'change', type: 'array', min: 1 }
                    ],
                    exchangeCoinArr: [
                        { required: true, message: '请选择兑换面额', trigger: 'change', type: 'array', min: 1 }
                    ]
                },
                classOptions: [],
                cascaderProps: {
                    multiple: true,
                    checkStrictly: true,
                    value: 'value',
                    label: 'label',
                    children: 'children'
                },
                coinOptions: []
            }
        },
        created() {
            this.getDeptData();
        },
        methods: {
            indexMethod(index) {
                return (this.common.page - 1) * this.common.pageSize + (index + 1);
            },
            getDeptData() {
                let url = this.listDeptUrl;
                let data = { parentId: "0" };
                this.apiPost(url, data).then((res) => {
                    if (res.status == 200) {
                        this.depts = res.data.list;
                        if (this.depts.length > 0) {
                            this.form.deptId = this.depts[0].id;
                        }
                        this.getData();
                    } else {
                        this.$commonFn.showTip(res.message, 3);
                    }
                }, (err) => { console.log(err); });
            },
            getData() {
                this.loading = true;
                let url = this.coinExchangeListUrl;
                let startDate = "";
                let endDate = "";
                if (this.form.dateRange && this.form.dateRange.length == 2) {
                    startDate = this.form.dateRange[0];
                    endDate = this.form.dateRange[1];
                }
                let data = {
                    isPage: 1,
                    page: this.common.page,
                    limit: this.common.pageSize,
                    deptId: this.form.deptId,
                    startDate: startDate,
                    endDate: endDate
                };
                this.apiPost(url, data).then((res) => {
                    if (res.status == 200) {
                        this.data = res.data.list;
                        this.common.total = res.data.total;
                    } else {
                        this.$commonFn.showTip(res.message, 3);
                    }
                    this.loading = false;
                }, (err) => {
                    console.log(err);
                    this.loading = false;
                });
            },
            getClassOptions() {
                let url = this.getDeptCascaderUrl;
                let data = {};
                this.apiPost(url, data).then((res) => {
                    if (res.status == 200) {
                        this.classOptions = this.filterDeptOptions(res.data.selects);
                    } else {
                        this.$commonFn.showTip(res.message, 3);
                    }
                }, (err) => {
                    console.log(err);
                });
            },
            filterDeptOptions(nodes) {
                if (!Array.isArray(nodes)) {
                    return [];
                }
                let res = [];
                for (let i = 0; i < nodes.length; i++) {
                    let n = nodes[i];
                    let children = this.filterDeptOptions(n.children);
                    let match = (n.parentId === 0) || (this.$util.isNotEmpty(n.label) 
                            && (n.label.indexOf('年级') > -1));
                    if (match || (children && children.length > 0)) {
                        res.push(Object.assign({}, n, { children }));
                    }
                }
                return res;
            },
            flattenClassOptions(nodes, prefix) {
                if (!Array.isArray(nodes)) {
                    return [];
                }
                let res = [];
                for (let i = 0; i < nodes.length; i++) {
                    let n = nodes[i];
                    let label = prefix ? prefix + ' - ' + n.label : n.label;
                    if (n.children && n.children.length > 0) {
                        if (n.parentId == '0') {
                            res.push({ id: n.value || n.id, label: label });
                        }
                        res = res.concat(this.flattenClassOptions(n.children, label));
                    } else {
                        res.push({ id: n.value || n.id, label: label });
                    }
                }
                return res;
            },
            getCoinOptions() {
                let url = this.schoolCoinListUrl;
                let data = {
                    isPage: 1,
                    page: 1,
                    limit: 100,
                    deptId: this.form.deptId
                };
                this.apiPost(url, data).then((res) => {
                    if (res.status == 200) {
                        let list = res.data.list || [];
                        this.coinOptions = list.map(item => {
                            return {
                                id: item.id,
                                label: item.coinDenomination+'元'+item.coinName + '（' + this.formatEvaluateType(item.evaluateType) + '）-兑换'+item.correspondingPoints+"得星"
                            };
                        });
                    } else {
                        this.$commonFn.showTip(res.message, 3);
                    }
                }, (err) => {
                    console.log(err);
                });
            },
            showExchangeDialog() {
                this.exchangeVisible = true;
                this.exchangeForm.exchangeClass = [];
                this.exchangeForm.exchangeCoinArr = [];
                this.getClassOptions();
                this.getCoinOptions();
                this.$nextTick(() => {
                    if (this.$refs['exchangeForm']) {
                        this.$refs['exchangeForm'].clearValidate();
                    }
                });
            },
            saveExchange() {
                this.$refs['exchangeForm'].validate((valid) => {
                    if (valid) {
                        let url = this.coinExchangeSaveUrl;
                        let data = {
                            deptId: this.form.deptId,
                            bindId: this.exchangeForm.exchangeClass.map(arr => arr[arr.length - 1]).join(','),
                            coinId: this.exchangeForm.exchangeCoinArr.join(',')
                        };
                        let loadingInstance = this.$loading({
                            lock: true,
                            text: '正在兑换中，兑换过程时间可能会比较长，请耐心等待',
                            spinner: 'el-icon-loading',
                            background: 'rgba(255, 255, 255, 0.7)'
                        });
                        this.apiPost(url, data).then((res) => {
                            loadingInstance.close();
                            if (res.status == 200) {
                                this.exchangeVisible = false;
                                let d = res.data || {};
                                this.resultData.successList = d.successList || [];
                                this.resultData.errorList = d.errorList || [];
                                this.resultData.stockErrorList = d.stockErrorList || [];
                                this.resultVisible = true;
                                this.getData();
                            } else {
                                this.$commonFn.showTip(res.message, 3);
                            }
                        }, (err) => {
                            loadingInstance.close();
                            console.log(err);
                        });
                    }
                });
            },
            exportExcel(row) {
                let url = this.coinExchangeExportUrl;
                let param = new URLSearchParams();
                param.append('deptId', row.deptId);
                param.append('coinExchangeListId', row.id);

                let loadingInstance = this.$loading({
                    lock: true,
                    text: '正在导出中，导出过程时间可能会比较长，请耐心等待',
                    spinner: 'el-icon-loading',
                    background: 'rgba(255, 255, 255, 0.7)'
                });
                axios({
                    method: "post",
                    url: url,
                    data: param,
                    responseType: "blob"
                }).then(res => {
                    loadingInstance.close();
                    const link = document.createElement("a");
                    let blob = new Blob([res.data], { type: "application/vnd.ms-excel" });
                    link.style.display = "none";
                    link.href = URL.createObjectURL(blob);
                    let timeStr = this.$moment().format("YYYYMMDDHHmmss");
                    link.setAttribute("download", '兑币清单_' + timeStr + '.xls');
                    document.body.appendChild(link);
                    link.click();
                    document.body.removeChild(link);
                }).catch(error => {
                    loadingInstance.close();
                    console.log(error);
                    this.$commonFn.showTip('导出失败，请稍后重试', 3);
                });
            },
            revoke(row) {
                this.$commonFn.showConfirm2('确认撤销该兑换记录吗？', () => {
                    let loadingInstance = this.$loading({
                        lock: true,
                        text: '正在撤销中，请耐心等待',
                        spinner: 'el-icon-loading',
                        background: 'rgba(255, 255, 255, 0.7)'
                    });
                    let url = this.coinExchangeRevokeUrl;
                    let data = { id: row.id };
                    this.apiPost(url, data).then((res) => {
                        loadingInstance.close();
                        if (res.status == 200) {
                            this.$commonFn.showTip(res.message, 1);
                            this.getData();
                        } else {
                            this.$commonFn.showTip(res.message, 3);
                        }
                    }, (err) => {
                        loadingInstance.close();
                        console.log(err);
                    });
                });
            },
            del(row) {
                this.$commonFn.showConfirm2('确认删除该兑换记录吗？', () => {
                    let loadingInstance = this.$loading({
                        lock: true,
                        text: '正在删除中，请耐心等待',
                        spinner: 'el-icon-loading',
                        background: 'rgba(255, 255, 255, 0.7)'
                    });
                    let url = this.coinExchangeRemoveUrl;
                    let data = { id: row.id };
                    this.apiPost(url, data).then((res) => {
                        loadingInstance.close();
                        if (res.status == 200) {
                            this.$commonFn.showTip(res.message, 1);
                            this.getData();
                        } else {
                            this.$commonFn.showTip(res.message, 3);
                        }
                    }, (err) => {
                        loadingInstance.close();
                        console.log(err);
                    });
                });
            },
            formatEvaluateType(val) {
                if (!val) return '';
                const map = { '1': '德育', '2': '智育', '3': '体育', '4': '美育', '5': '劳育' };
                return map[val] || val;
            },
            handleSizeChange(val) {
                this.common.pageSize = val;
                this.common.page = 1;
                this.getData();
            },
            handleCurrentChange(val) {
                this.common.page = val;
                this.getData();
            }
        },
        mixins: [http]
    }
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/page/schoolCoin/coinExchange/list.vue